<div class="form-group">
    <button mat-raised-button color="primary" (click)="libraryImport.click()"  [disabled]="importListener?.pending">
        <mat-icon>publish</mat-icon>
        <ng-container i18n="@@importExport-importLibrary">Importer</ng-container>
    </button>&nbsp;
    <input #libraryImport type="file" multiple (change)="onFileInput($event)" style="display:none;" accept=".json">
</div>
